export default "__VITE_ASSET__BJwtJEkA__"